import { render, staticRenderFns } from "./ClientMarks.vue?vue&type=template&id=6cf442d1&scoped=true"
import script from "./ClientMarks.vue?vue&type=script&lang=js"
export * from "./ClientMarks.vue?vue&type=script&lang=js"
import style0 from "./ClientMarks.vue?vue&type=style&index=0&id=6cf442d1&prod&scoped=true&lang=css"
import style1 from "./ClientMarks.vue?vue&type=style&index=1&id=6cf442d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf442d1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseTooltip: require('/var/www/git/queue/front/components/BaseTooltip.vue').default})
